"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DixaCountry = exports.DixaLanguage = exports.DixaEvent = void 0;
var DixaEvent;
(function (DixaEvent) {
    DixaEvent["AgentAssigned"] = "on-agent-assigned";
    DixaEvent["AgentUnassigned"] = "on-agent-unassigned";
    DixaEvent["ConversationEnded"] = "on-conversation-ended";
    DixaEvent["ConversationStarted"] = "on-conversation-started";
    DixaEvent["MessageAdded"] = "on-message-added";
    DixaEvent["UserIdentityChanged"] = "on-user-identity-changed";
    DixaEvent["UserPurged"] = "on-user-purged";
    DixaEvent["ViewChanged"] = "on-view-changed";
    DixaEvent["WidgetFocusChanged"] = "on-widget-focus-changed";
    DixaEvent["WidgetOpenChanged"] = "on-widget-open-changed";
})(DixaEvent || (exports.DixaEvent = DixaEvent = {}));
var DixaLanguage;
(function (DixaLanguage) {
    DixaLanguage["en"] = "en";
    DixaLanguage["de"] = "de";
    DixaLanguage["nl"] = "nl";
    DixaLanguage["es"] = "es";
})(DixaLanguage || (exports.DixaLanguage = DixaLanguage = {}));
var DixaCountry;
(function (DixaCountry) {
    DixaCountry["DE"] = "de";
    DixaCountry["AT"] = "at";
    DixaCountry["NL"] = "nl";
    DixaCountry["ES"] = "es";
    DixaCountry["US"] = "us";
})(DixaCountry || (exports.DixaCountry = DixaCountry = {}));
//# sourceMappingURL=dixa.js.map